<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0025-01-0"><a id="page19"></a><a href="#/contents#fn_18" id="sn_18">DAY 18</a></p>
<p class="ct1"><a href="#/contents#fn_18">LIFE IN THE ARK—AND YOU ARE THERE!</a></p>
<p class="ext"><span><i>For forty days the flood kept coming on the earth. The waters flooded the earth for a hundred and fifty days.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 7:17, 24</span></p>
<p class="tx1" id="p0025-04-4"><span class="dcap">I</span>t lasted a little longer than a year, that multisensory experience on steroids. Yes, we’re talking about Noah’s extraordinary time aboard the ark.</p>
<p class="tx">Sights: Parrots, peacocks, pandas, polar bears.</p>
<p class="tx">Sounds: Caws, growls, roars, trumpetings.</p>
<p class="tx">Touch: Puppies, porcupines, kittens, snakes.</p>
<p class="tx">Smells: Unhappy skunks. And the stable floors . . .</p>
<p class="tx">Tastes: With smells that intense, who could really taste food?</p>
<p class="tx">God calls. We obey, and it’s not always a luxury cruise.</p>
<p class="tx">God had told Noah to bring onboard the ark “two of all living creatures, male and female” (Genesis 6:19). The future of the animal world was, literally, riding with Noah! Noah could at least know the satisfaction of obeying God. The rest was up to the Almighty.</p>
<p class="tx">And maybe that solid sense of contentment that comes with obeying God made the sounds and smells very, very unimportant.</p>
<p class="tx3">WHATEVER THE SURROUNDINGS, BEING RIGHT WHERE GOD WANTS US TO BE IS BETTER THAN BEING ANYWHERE ELSE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter21.vue?96f94476